import { Manifesto } from "@/components/site/Manifesto";
import { TrustStrip } from "@/components/site/TrustStrip";

export default function Philosophy() {
  return (
    <main data-testid="philosophy-page" className="pt-28 lg:pt-36">
      <Manifesto />
      <TrustStrip />
    </main>
  );
}
